export const LISTBOX_PADDING = 8; // px
